export default __webpack_public_path__ + "1f4283e63cd02423dfe3e11ae56fa0cf.png";